// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_dee2b3', '__Poppins_Fallback_dee2b3', Helvetica Neue, Arial, sans-serif","fontStyle":"normal"},"className":"__className_dee2b3"};